import { Dispatch, SetStateAction } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'

interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

const ModalInfoDropset = ({ isOpen, setIsOpen }: Props) => {
  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} fullWidth>

      <DialogTitle className='flex justify-center text-orangeTr4iner'> Dropset </DialogTitle>

      <DialogContent className='font-medium' dividers>
        Es una técnica para aumentar la intensidad del ejercicio. <br />
        Consiste en realizar una serie con un peso determinado y, al terminar, reducir el peso y continuar haciendo más repeticiones sin descansar. <br />
        Este proceso puede repetirse varias veces. <br />

        ✅ Ejemplo: realizas 10 repeticiones con 20 kg, bajas a 15 kg y haces 8 repeticiones más, luego vuelves a bajar a 10 kg y haces las repeticiones que puedas manteniendo una buena técnica.
      </DialogContent>

      <DialogActions>
        <button
          onClick={() => setIsOpen(false)}
          className="text-white bg-black p-2 rounded-lg"
        >
          Cerrar
        </button>
      </DialogActions>

    </Dialog>
  )
}

export default ModalInfoDropset;
